export default {
  sessionStatus: {
    PENDING: "In corso",
    CONFIRMED: "Confermata",
    EXPIRED: "Scaduta",
    CANCELLED: "Annullata",
  },
  messageStatus: {
    DELIVERED: "Consegnato",
    BLOCKED: "Bloccato",
  },
  sender: {
    CUSTOMER: "Cliente",
    SELLER: "Venditore",
    ADMIN: "Staff",
    SYSTEM: "Sistema",
  },
  channel: {
    WHATSAPP: "WhatsApp",
    SMS: "SMS",
    EMAIL: "Email",
  },
  messageInput: {
    send: "Invia",
  },
  bubble: {
    agreementDetected: "Accordo rilevato",
  },
  audit: {
    blockReason: "Motivo del blocco",
    gptAnalysis: "Metadati di moderazione",
    sent: "Inviata",
    notSent: "Non inviata",
    internalNote: "Interno (non inviato al cliente)",
    viaChannel: "via {{channel}}",
  },
  listItem: {
    agreementReached: "✅ Accordo raggiunto",
  },
  filters: {
    allSellers: "Tutti i venditori",
    panelTitle: "Filtri",
    clearAll: "Cancella tutto",
    status: "Stato",
    channel: "Canale",
    customerName: "Nome cliente",
    customerNamePlaceholder: "Cerca per nome cliente…",
    dateRange: "Intervallo date",
    from: "Da",
    to: "A",
    seller: "Venditore",
    clear: "Cancella",
    search: "Cerca",
  },
} as const;
